var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.8572C1 21.023 4.22355 24.4 8.2 24.4H9H25H25.8C29.7765 24.4 33 21.023 33 16.8572C33 13.569 30.9916 10.7722 28.1899 9.73976C28.1966 9.59883 28.2 9.45698 28.2 9.3143C28.2 4.68563 24.6183 0.93335 20.2 0.93335C15.7817 0.93335 12.2 4.68563 12.2 9.3143C12.2 9.7715 12.2349 10.2201 12.3022 10.6575C11.1383 9.81064 9.72446 9.3143 8.2 9.3143C4.22355 9.3143 1 12.6914 1 16.8572Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 27.4815L17.25 31.8667M17.25 31.8667L13.25 27.4815M17.25 31.8667L17.25 16.9333",
    stroke: "#8E8E8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.aa91979b2d653887ad281bd3b302e63f.svg";
export { ForwardRef as ReactComponent };